import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { searchContracts } from "../../API/ApiContratos";
import { AuthContext } from "../../auth/authContext";
import { toast } from "react-toastify";
import { getApiEstadoCobranzaContrato } from "../../API/ApiEstadoCobranzaContrato";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

export const BuscadorDeContratosComponent = () => {
  const { user, dispatch } = React.useContext(AuthContext);
  const [finalData, setFinalData] = React.useState([]);
  const [numeroContrato, setNumeroContrato] = React.useState(0);
  const [selectedValue, SetSelectedValue] = React.useState("");
  const [numeroContratoBoton, setNumeroContratoBoton] = React.useState(0);

  // Estado para el modal y los datos del contrato
  const [openModal, setOpenModal] = React.useState(false);
  const [detalleContrato, setDetalleContrato] = React.useState(null);

  const handleCloseModal = () => setOpenModal(false);

  return (
    <>
      <Autocomplete
        disablePortal
        id="combo-box-demo"
        options={finalData}
        getOptionLabel={(option) =>
          `${option.serie} ${option.noContrato} -${option.titular}`
        }
        onInputChange={(event, option) => {
          searchContracts(user, event.target.value).then((resultado) => {
            if (resultado.status == 200) {
              setFinalData(resultado.data);
            } else {
              setFinalData([]);
            }
          });
        }}
        onChange={(event, option) => {
          const mostrarResumen = localStorage.getItem('mostrar_resumen_contrato') === 'true';
          setNumeroContratoBoton(option.id);
          if (mostrarResumen == true) {
            getApiEstadoCobranzaContrato(user, option.id).then((resultado) => {
              if (resultado.status == 200) {
                toast.info("Mostrando el detalle del contrato");
                setDetalleContrato(resultado.data);
                setOpenModal(true);
              }
            });
          } else {
            window.open("/contrato/" + option.id + "/false", "_self");
            return;
          }
        }}
        sx={{ width: "100%" }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Buscar Número de Contrato"
            onChange={e => setNumeroContratoBoton(e.target.value)}
          />
        )}
      />

      <br />
      <button
        className="btn btn-sm btn-success"
        onClick={() => {
          window.open("/contrato/" + numeroContratoBoton + "/false", "_self");
        }}
      >
        Buscar
      </button>
      <br />

      {/* Modal para mostrar el resumen del contrato */}
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-contrato-title"
        aria-describedby="modal-contrato-description"
      >
        <Box sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          maxHeight: "90vh",
          overflow: "auto",
          bgcolor: "background.paper",
          border: "2px solid #000",
          boxShadow: 24,
          p: 4,
        }}>
          <h5 id="modal-contrato-title">Resumen de Contrato</h5>
          {detalleContrato && (
            <>
              <table className="table table-sm">
                <tbody>
                  <tr>
                    <th>Serie</th>
                    <td>{detalleContrato.serie}</td>
                  </tr>
                  <tr>
                    <th>Número de Contrato</th>
                    <td>{detalleContrato.noContrato}</td>
                  </tr>
                  <tr>
                    <th>Titular</th>
                    <td>{detalleContrato.titular}</td>
                  </tr>
                  <tr>
                    <th>Servicio Contratado</th>
                    <td>{detalleContrato?.servicioContratado?.nombre}</td>
                  </tr>
                  <tr>
                    <th>Plazo Contrato</th>
                    <td>{detalleContrato.plazoContrato}</td>
                  </tr>
                  <tr>
                    <th>Fecha Inicio</th>
                    <td>{detalleContrato.fechaInicioContrato}</td>
                  </tr>
                  <tr>
                    <th>Fecha Fin</th>
                    <td>{detalleContrato.fechaFinContrato}</td>
                  </tr>
                  <tr>
                    <th>Meses Transcurridos</th>
                    <td>{detalleContrato.mesesTranscurridosContratoHoy}</td>
                  </tr>
                  <tr>
                    <th>Monto Pago Mensual</th>
                    <td>{detalleContrato.montoPagoSugeridoMensual}</td>
                  </tr>
                  <tr>
                    <th>Importe</th>
                    <td>{detalleContrato.importe}</td>
                  </tr>
                  <tr>
                    <th>Pagos al Momento</th>
                    <td>{detalleContrato.pagosAlMomento}</td>
                  </tr>
                  <tr>
                    <th>Saldo</th>
                    <td>{detalleContrato.saldo}</td>
                  </tr>
                  <tr>
                    <th>Fecha Último Pago</th>
                    <td>{detalleContrato.fechaUltimoPago}</td>
                  </tr>
                  <tr>
                    <th>Número de Pagos Capturados</th>
                    <td>{detalleContrato.numeroPagosCapturados}</td>
                  </tr>
                  <tr>
                    <th>Monto Vencido</th>
                    <td>{detalleContrato.montoVencido}</td>
                  </tr>
                </tbody>
              </table>
              <button
                className="btn btn-sm btn-primary w-100 mb-2"
                onClick={() => {
                  window.open("/contrato/" + numeroContratoBoton + "/false", "_self");
                }}
              >
                Ir al contrato
              </button>
            </>
          )}
          <button className="btn btn-sm btn-secondary w-100 mt-2" onClick={handleCloseModal}>
            Cerrar
          </button>
        </Box>
      </Modal>
    </>
  );
};
